import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	subgroupHeader: {
		padding: "14px 14px 8px",
		gap: "12px"
	},
	subgroupLabel: {
		textTransform: "uppercase",
		fontSize: "13px",
		fontWeight: 700,
		letterSpacing: "0.05em",
		color: colors.gray[700]
	},
	subgroupCount: {
		fontSize: "11px",
		color: colors.gray[400]
	},
	itemsContainer: {
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "8px",
		overflow: "hidden"
	},
	itemRow: {
		padding: "12px 14px",
		gap: "16px",
		cursor: "pointer",
		"&:hover": {
			backgroundColor: colors.purple[50]
		}
	},
	itemBorder: {
		borderBottom: `1px solid ${colors.gray[100]}`
	},
	itemLabel: {
		fontWeight: 700,
		fontSize: "12px",
		color: colors.gray[900]
	},
	itemDescription: {
		fontSize: "11px",
		lineHeight: 1.45,
		color: colors.gray[500]
	}
}))

export default useStyles
